
export default function Footer() {
  return (
    <footer className="bg-zinc-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Seneca Tire Shop
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Your trusted source for quality new and used tires in Seneca. Expert service, competitive prices, and customer satisfaction guaranteed.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="#home" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Home</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Services</a></li>
              <li><a href="#products" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Products</a></li>
              <li><a href="#about" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Tire Installation</li>
              <li className="text-gray-400">Tire Repair</li>
              <li className="text-gray-400">Wheel Alignment</li>
              <li className="text-gray-400">Tire Balancing</li>
              <li className="text-gray-400">Free Inspection</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-400">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span>123 Main Street<br />Seneca, SC 29678</span>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-phone-line mr-2"></i>
                <span>(864) 555-8473</span>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-mail-line mr-2"></i>
                <span>info@senecatire.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 Seneca Tire Shop. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
